import { render, staticRenderFns } from "./ProductDifferentiation.vue?vue&type=template&id=37a0dde2&scoped=true"
import script from "./ProductDifferentiation.vue?vue&type=script&lang=js"
export * from "./ProductDifferentiation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a0dde2",
  null
  
)

export default component.exports